module.exports = __webpack_public_path__ + "img/clic_off.f87be822.gif";